import { type FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useWorkspaceStore } from '@/stores/workspace.store';

interface SidebarProps {
  open?: boolean;
  onClose?: () => void;
}

const navLinkStyle = (isActive: boolean): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--spacing-sm)',
  padding: 'var(--spacing-sm) var(--spacing-md)',
  borderRadius: 'var(--radius-md)',
  fontSize: 'var(--font-size-sm)',
  fontWeight: isActive ? 600 : 400,
  color: isActive ? 'var(--color-text)' : 'var(--color-text-muted)',
  backgroundColor: isActive ? 'var(--color-background)' : 'transparent',
  textDecoration: 'none',
  transition: 'var(--transition-fast)',
});

export const Sidebar: FC<SidebarProps> = ({ open = false, onClose }) => {
  const workspaces = useWorkspaceStore((s) => s.workspaces);

  return (
    <>
      {/* Mobile backdrop */}
      <div
        className="sidebar-backdrop"
        data-open={open ? 'true' : 'false'}
        onClick={onClose}
      />
      <aside className="sidebar" data-open={open ? 'true' : 'false'}>
        <nav
          style={{
            flex: 1,
            padding: 'var(--spacing-md)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--spacing-xs)',
            overflowY: 'auto',
          }}
        >
          <NavLink to="/dashboard" style={({ isActive }) => navLinkStyle(isActive)}>
            Dashboard
          </NavLink>

          <div
            style={{
              marginTop: 'var(--spacing-lg)',
              marginBottom: 'var(--spacing-sm)',
            }}
          >
            <span
              style={{
                fontSize: 'var(--font-size-xs)',
                fontWeight: 600,
                color: 'var(--color-text-muted)',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              Workspaces
            </span>
          </div>

          {workspaces.map((workspace) => (
            <NavLink
              key={workspace.id}
              to={`/workspaces/${workspace.id}`}
              style={({ isActive }) => navLinkStyle(isActive)}
            >
              {workspace.name}
            </NavLink>
          ))}

          {workspaces.length === 0 && (
            <span
              style={{
                fontSize: 'var(--font-size-sm)',
                color: 'var(--color-text-muted)',
                padding: 'var(--spacing-sm) var(--spacing-md)',
              }}
            >
              No workspaces yet
            </span>
          )}

          <div
            style={{
              marginTop: 'auto',
              paddingTop: 'var(--spacing-lg)',
              borderTop: '1px solid var(--color-border)',
            }}
          >
            <NavLink
              to="/settings/api-tokens"
              style={({ isActive }) => navLinkStyle(isActive)}
            >
              Jetons API (MCP)
            </NavLink>
            <NavLink
              to="/settings/oauth-clients"
              style={({ isActive }) => navLinkStyle(isActive)}
            >
              Clients OAuth
            </NavLink>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
